/* eslint-disable import/no-unresolved */

/* eslint-enable import/no-unresolved */
import React from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function singleOrPlural(entityName, entityNamePluralised, condition) {
  return condition === 1 ? "".concat(entityName) : "".concat(entityNamePluralised || "".concat(entityName, "s"));
}
export function formatSelectButtonText(totalNumOfTableRows, entityName, entityNamePluralised) {
  if (!totalNumOfTableRows) return null;
  var nameOrNames = singleOrPlural(entityName, entityNamePluralised, totalNumOfTableRows);
  if (totalNumOfTableRows === 1) {
    return "Select 1 ".concat(entityName);
  }
  return "Select all ".concat(totalNumOfTableRows, " ").concat(nameOrNames);
}
export function getSelectAllButtonProps(selectableRows, selectLogic, totalNumOfTableRows, entityName, entityNamePluralised) {
  if (!selectableRows || !selectLogic || !totalNumOfTableRows) return null;
  var allSelected = selectLogic === null || selectLogic === void 0 ? void 0 : selectLogic.state.all;
  if (allSelected) {
    return {
      children: "Clear selection",
      onClick: function onClick() {
        return selectLogic.fns.onToggleAll({});
      }
    };
  }
  var labelText = formatSelectButtonText(totalNumOfTableRows, entityName, entityNamePluralised);
  return {
    children: labelText,
    onClick: function onClick() {
      return selectLogic.fns.onToggleAll({
        isPartialToAll: true
      });
    }
  };
}
export function getNumOfRowsSelected(selectableRows, numOfRowsSelected, totalRows, entityName, entityNamePluralised) {
  if (!selectableRows || !numOfRowsSelected || !totalRows) return null;
  var nameOrNames = singleOrPlural(entityName, entityNamePluralised, numOfRowsSelected);
  if (numOfRowsSelected === totalRows) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: ["All ", /*#__PURE__*/_jsx("strong", {
        children: totalRows
      }), " ", nameOrNames, " selected"]
    });
  }
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("strong", {
      children: numOfRowsSelected
    }), " ", nameOrNames, " selected"]
  });
}